import { render, staticRenderFns } from "./AdvList.vue?vue&type=template&id=6cb0ee8c&"
import script from "./AdvList.vue?vue&type=script&lang=js&"
export * from "./AdvList.vue?vue&type=script&lang=js&"
import style0 from "./AdvList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports